import { CALL_API, Schemas } from '../../../common/middleware/api';

export const SENT_EMAILS_REPORT_REQUEST = 'SENT_EMAILS_REPORT_REQUEST';
export const SENT_EMAILS_REPORT_SUCCESS = 'SENT_EMAILS_REPORT_SUCCESS';
export const SENT_EMAILS_REPORT_FAILURE = 'SENT_EMAILS_REPORT_FAILURE';

// listKey: the list the results belong to when it isn't the report or a parent's emails (e.g. a subscription's notices)
export const loadSentEmails = (options, listKey) => ({
	[CALL_API]: {
		types: [SENT_EMAILS_REPORT_REQUEST, SENT_EMAILS_REPORT_SUCCESS, SENT_EMAILS_REPORT_FAILURE],
		endpoint: 'api/sentEmails',
		request: options,
		method: 'POST',
		schema: Schemas.SENT_EMAILS_ARRAY,
		form: 'sentEmailsFilter'
	},
	parentId: options && options.parentId,
	listKey
});